// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__v8DbN","content":"Search_content__7sNeS","sidebar":"Search_sidebar__RvayA"};